import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

type PageShellProps = {
  children: ReactNode;
  topOffset?: boolean;
  className?: string;
};

export default function PageShell({ children, topOffset = true, className = "" }: PageShellProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className={`flex-1 ${topOffset ? "pt-16 md:pt-[72px]" : ""} ${className}`}>{children}</main>
      <SiteFooter />
    </div>
  );
}